// extracted by mini-css-extract-plugin
export default {"layoutContainer":"layoutContainer__dXVKA","haveHeader":"haveHeader__7k+fG","haveFooter":"haveFooter__nTFbt"};